import {Observable} from 'rxjs';

export interface ProjectType {
    id?: number;
    name: string;
    active?: boolean;
    /** Controla si en proyectos se muestra el dropdown de niveles/subcódigos al crear o editar hijos. */
    mostrarListaNiveles?: boolean;
}

export abstract class ProjectTypesData {
    abstract list(search: string, pageNumber: number, pageSize: number, orderBy: string): Observable<any>;
    abstract get(id: number): Observable<ProjectType>;
    abstract update(projectType: ProjectType): Observable<ProjectType>;
    abstract create(projectType: ProjectType): Observable<ProjectType>;
    abstract delete(projectType: ProjectType): Observable<ProjectType>;
}

